module.exports = __webpack_public_path__ + "static/media/Shanghai-alexandre-valdivia.db239cc9.jpg";